import { render, staticRenderFns } from "./ConfigTime.vue?vue&type=template&id=94b09c7e"
import script from "./ConfigTime.vue?vue&type=script&lang=js"
export * from "./ConfigTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports